import {ProductTicketType} from '../../../../models/ems/ProductModel'

export const ProductTypeColumn = ({data}: {data: {type: ProductTicketType}}) => {
  return <span className='badge badge-light-success text-uppercase'>{data.type}</span>
}
